module.exports = __webpack_public_path__ + "media/images/jamicons/alert-40a94bd0ef484a57c8327f0dec7e3235.svg";